import Button from './Button';
export default Button;
//# sourceMappingURL=index.js.map